import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";


const boardMemberManagementApi = createApi({
    reducerPath: 'boardMemberManagementApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllBoardMemberList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/BoardMemberManagement/GetAllBoardMemberList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditBoardMember: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/BoardMemberManagement/AddEditBoardMember`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteBoardMemberById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/BoardMemberManagement/DeleteBoardMemberById?id=${parseInt(id)}`),
                method: 'POST',                
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
// 
export const {
    useGetAllBoardMemberListMutation,
    useAddEditBoardMemberMutation,
    useLazyDeleteBoardMemberByIdQuery

} = boardMemberManagementApi;

export default boardMemberManagementApi;